<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import DatePicker from "vue2-datepicker";
import moment from "moment";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
/**
 * Starter component
 */
export default {
    components: { Layout, PageHeader, DatePicker },
    data() {
        return {
            title: "Pagos Laborantes",
            items: [
                {
                text: "Laborantes",
                href: "/"
                },
                {
                text: "Pago",
                active: true
                }
            ],
            laborantes_por_pagar:[],
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filtro: '',
            mesFiltro: '',
            desde: '',
            hasta: '',
            laborantes:[],
            eventos:[],
            apagar:[]
        };
    },
    computed:{
        rows() {
            return this.filteredData.length;
        },
        filteredData() {
            const filtro = this.normalizarTexto(this.filtro);

            return this.sortedData.filter((item) => {
                const fecha = moment(item.fecha).format('YYYY-MM-DD');

                if (this.desde && fecha < this.desde) {
                    return false;
                }

                if (this.hasta && fecha > this.hasta) {
                    return false;
                }

                if (this.mesFiltro && moment(item.fecha).format('YYYY-MM') !== this.mesFiltro) {
                    return false;
                }

                if (!filtro) {
                    return true;
                }

                const laborante = this.obtenerLabotante(item.laborante_id);
                const sede = this.obtenerSede(item.laborante_id);
                const evento = this.obtenerEvento(item.evento_id);

                return [
                    laborante,
                    sede,
                    this.formatFecha(item.fecha),
                    item.hora_inicio,
                    item.hora_fin,
                    evento.codigo,
                    evento.coordinador_evento,
                    item.valor_bruto,
                    item.valor_liquido,
                ].some((valor) => this.normalizarTexto(valor).includes(filtro));
            });
        },
        sortedData() {
            // Ordenar por valor_liquido de mayor a menor
            return [...this.laborantes_por_pagar].sort((a, b) => {
                const montoA = parseInt(a.valor_liquido) || 0;
                const montoB = parseInt(b.valor_liquido) || 0;
                return montoB - montoA; // Mayor a menor
            });
        },
        paginatedData() {
            const start = (this.currentPage - 1) * this.perPage;
            const end = start + this.perPage;
            return this.filteredData.slice(start, end)
        },
        totalPages() {
            return Math.ceil(this.filteredData.length / this.perPage);
        },
        mesOptions() {
            const meses = [...new Set(this.laborantes_por_pagar
                .filter((item) => item.fecha)
                .map((item) => moment(item.fecha).format('YYYY-MM')))]
                .sort()
                .reverse();

            return [
                { value: '', text: 'Todos los meses' },
                ...meses.map((mes) => ({
                    value: mes,
                    text: moment(`${mes}-01`).format('MMMM YYYY'),
                })),
            ];
        },
        rangoVisible() {
            if (this.rows === 0) {
                return 'Mostrando 0 de 0 recibos';
            }

            const inicio = ((this.currentPage - 1) * this.perPage) + 1;
            const fin = Math.min(this.currentPage * this.perPage, this.rows);
            return `Mostrando ${inicio} a ${fin} de ${this.rows} recibos`;
        },
        resumenFiltrado() {
            const porLaborante = {};
            let totalBruto = 0;
            let totalLiquido = 0;
            let totalHoras = 0;

            this.filteredData.forEach((item) => {
                const laboranteId = item.laborante_id || 'sin-id';
                const nombre = this.obtenerLabotante(item.laborante_id) || 'Sin laborante';
                const valorBruto = this.obtenerNumero(item.valor_bruto);
                const valorLiquido = this.obtenerNumero(item.valor_liquido);
                const horas = this.obtenerNumeroDecimal(item.total_horas);

                totalBruto += valorBruto;
                totalLiquido += valorLiquido;
                totalHoras += horas;

                if (!porLaborante[laboranteId]) {
                    porLaborante[laboranteId] = {
                        nombre,
                        recibos: 0,
                        horas: 0,
                        bruto: 0,
                        liquido: 0,
                    };
                }

                porLaborante[laboranteId].recibos += 1;
                porLaborante[laboranteId].horas += horas;
                porLaborante[laboranteId].bruto += valorBruto;
                porLaborante[laboranteId].liquido += valorLiquido;
            });

            const laborantes = Object.values(porLaborante);

            return {
                recibos: this.filteredData.length,
                laborantes: laborantes.length,
                totalHoras,
                totalBruto,
                totalLiquido,
                mayorRecibos: this.obtenerMayor(laborantes, 'recibos'),
                mayorHoras: this.obtenerMayor(laborantes, 'horas'),
                mayorLiquido: this.obtenerMayor(laborantes, 'liquido'),
                mayorBruto: this.obtenerMayor(laborantes, 'bruto'),
            };
        },
    },
    methods:{
        normalizarTexto(valor) {
            return (valor || '')
                .toString()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .toLowerCase()
                .trim();
        },
        obtenerNumero(valor) {
            if (valor === null || valor === undefined) {
                return 0;
            }
            if (typeof valor === 'number') {
                return valor;
            }
            return parseInt(valor.toString().replace(/[^0-9-]/g, ''), 10) || 0;
        },
        obtenerNumeroDecimal(valor) {
            if (valor === null || valor === undefined) {
                return 0;
            }
            if (typeof valor === 'number') {
                return valor;
            }
            return parseFloat(valor.toString().replace(',', '.')) || 0;
        },
        obtenerMayor(items, campo) {
            if (!items.length) {
                return null;
            }

            return items.reduce((mayor, item) => {
                return item[campo] > mayor[campo] ? item : mayor;
            }, items[0]);
        },
        formatHoras(valor) {
            const numero = Number(valor || 0);
            return numero.toLocaleString('es-CL', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 2,
            });
        },
        obtenerRangoPagoActual() {
            const hoy = new Date();
            const diaHoy = hoy.getDate();
            const mesHoy = hoy.getMonth();
            const anioHoy = hoy.getFullYear();

            let fechaInicio;
            let fechaFin;

            if (diaHoy <= 25) {
                const mesAnterior = mesHoy === 0 ? 11 : mesHoy - 1;
                const anioInicio = mesHoy === 0 ? anioHoy - 1 : anioHoy;
                fechaInicio = new Date(anioInicio, mesAnterior, 26);
                fechaFin = new Date(anioHoy, mesHoy, 25);
            } else {
                const mesSiguiente = mesHoy === 11 ? 0 : mesHoy + 1;
                const anioFin = mesHoy === 11 ? anioHoy + 1 : anioHoy;
                fechaInicio = new Date(anioHoy, mesHoy, 26);
                fechaFin = new Date(anioFin, mesSiguiente, 25);
            }

            this.desde = moment(fechaInicio).format('YYYY-MM-DD');
            this.hasta = moment(fechaFin).format('YYYY-MM-DD');
            this.mesFiltro = '';
        },
        limpiarRangoFechas() {
            this.desde = '';
            this.hasta = '';
        },
        obtenerLabotante(element){
            let laborante = this.laborantes.filter((us) => us.id==element);
            if (laborante.length>0) {
                return laborante[0].name;
            }
            return '';
        },
        obtenerSede(element){
            let laborante = this.laborantes.filter((us) => us.id==element);
            if (laborante.length>0) {
                return laborante[0].sede;
            }
            return '';
        },
        obtenerEvento(element){
            let evento = this.eventos.filter((us) => us.id==element);
            if (evento.length>0) {
                return evento[0];
            }else{
                let evento={
                    codigo:'',
                    coordinador_evento:'',
                }
                return evento
            }
        },
        msg(title) {
            Swal.fire({
                icon: 'success',
                title: title,
                //text: `Por favor, completa el campo "${campo}".`,
                showConfirmButton: false,
                timer: 1000
            });
        },
        seleccionar(item){
            let formData = new FormData();
            formData.append('pago_id', item.id);
            formData.append('status', item.status);
            axios.post('/api/seleccionar_pago',formData).then(response => {
                this.msg('Guardado')
            });
        },
        formatFecha(fechahora){
            var orden = moment(fechahora).format('DD-MM-YYYY');
            return orden
        },
        format_Valor_variable(val){
            return val? parseInt(val.toString().replace(/[^0-9]/g, ''), 10)? parseInt(val.toString().replace(/[^0-9]/g, ''), 10).toLocaleString("es-CL", { style: "currency", currency: "CLP" }): '$0': '$0';
        },
        pagar(){
            this.laborantes_por_pagar.forEach(element => {
                if (element.status=='1') {
                    this.apagar.push(element);
                }
            });
            let formData = new FormData();
            formData.append('apagar', JSON.stringify(this.apagar));
            axios.post('/api/pagar',formData).then(response => {
                if(response.data.estado){
                    this.laborantes_por_pagar= response.data.laborantes;
                    this.msg('Laborantes Pagados');
                }
            });
        },
        async exportToExcelCompleto() {
            return this.runDownload('laborantes_excel_completo', async () => {
                try {
                    const response = await axios.get('/api/export_completo');
                    const data= response.data.array;
                    const ws = XLSX.utils.json_to_sheet(data);
                    const wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "Datos");
                    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
                    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
                    saveAs(blob, "datos.xlsx");
                } catch (error) {
                    Swal.fire({
                        icon: 'error',
                        title: 'No se pudo generar el archivo',
                        showConfirmButton: false,
                        timer: 2500
                    });
                }
            }, {
                message: 'Se esta generando el Excel completo. Esto puede tardar unos segundos.'
            });
        },
        async exportToExcelBancarios() {
            return this.runDownload('laborantes_excel_bancarios', async () => {
                try {
                    const response = await axios.get('/api/export_datos_bancarios');
                    const data = response.data.array;
                    const ws = XLSX.utils.json_to_sheet(data);
                    const wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "Datos");
                    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
                    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
                    saveAs(blob, "DatosBancarios.xlsx");
                } catch (error) {
                    Swal.fire({
                        icon: 'error',
                        title: 'No se pudo generar el archivo',
                        showConfirmButton: false,
                        timer: 2500
                    });
                }
            }, {
                message: 'Se esta generando el Excel bancario. Esto puede tardar unos segundos.'
            });
        }
    },
    created(){
        this.obtenerRangoPagoActual();
        axios.get('/api/get_laborantes_por_pagar').then(response => {
            this.laborantes_por_pagar= response.data.laborantes;
            this.currentPage = 1;
        });
        axios.get('/api/get_eventos').then(response => {
            this.eventos= response.data.eventos;
        });
        axios.get('/api/get_laborantes').then(response => {
            this.laborantes= response.data.usuarios;
        });
    }
    ,
    watch: {
        filtro() {
            this.currentPage = 1;
        },
        mesFiltro() {
            this.currentPage = 1;
        },
        desde() {
            this.currentPage = 1;
        },
        hasta() {
            this.currentPage = 1;
        },
        perPage() {
            this.currentPage = 1;
        }
    }
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body" v-if="laborantes_por_pagar.length>0">
                        <div class="row">
                            <div class="col-md-6 mb-3">
                                <b-button variant="primary" @click="exportToExcelCompleto" :disabled="isDownloadLoading('laborantes_excel_completo')">
                                    <b-spinner small class="mr-2" v-if="isDownloadLoading('laborantes_excel_completo')"></b-spinner>
                                    {{ getDownloadLabel('laborantes_excel_completo', 'Exportar excel completo', 'Generando excel completo...') }}
                                </b-button>
                                <b-button variant="primary" @click="exportToExcelBancarios" :disabled="isDownloadLoading('laborantes_excel_bancarios')">
                                    <b-spinner small class="mr-2" v-if="isDownloadLoading('laborantes_excel_bancarios')"></b-spinner>
                                    {{ getDownloadLabel('laborantes_excel_bancarios', 'Exportar datos bancarios', 'Generando datos bancarios...') }}
                                </b-button>
                            </div>
                            <div class="col-md-6 text-right mb-3">
                                <b-button variant="primary" @click="pagar()">Pagar Seleccionados</b-button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 col-md-4">
                                <div id="tickets-table_length" class="dataTables_length">
                                    <label class="d-inline-flex align-items-center">
                                        Mostrar&nbsp;
                                        <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;recibos
                                    </label>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-4">
                                <label class="d-inline-flex align-items-center">
                                    Mes:
                                    <b-form-select
                                        v-model="mesFiltro"
                                        size="sm"
                                        :options="mesOptions"
                                        class="ml-2"
                                    ></b-form-select>
                                </label>
                            </div>
                            <div class="col-sm-12 col-md-4">
                                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                                    <label class="d-inline-flex align-items-center">
                                        Buscar:
                                        <b-form-input
                                        v-model="filtro"
                                        type="search"
                                        placeholder="Buscar..."
                                        class="form-control form-control-sm ml-2"
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="row align-items-end mt-2">
                            <div class="col-sm-12 col-md-3">
                                <b-form-group label="Desde" label-class="mb-1">
                                    <date-picker v-model="desde" value-type="YYYY-MM-DD" format="DD-MM-YYYY" :first-day-of-week="2" lang="es"></date-picker>
                                </b-form-group>
                            </div>
                            <div class="col-sm-12 col-md-3">
                                <b-form-group label="Hasta" label-class="mb-1">
                                    <date-picker v-model="hasta" value-type="YYYY-MM-DD" format="DD-MM-YYYY" :first-day-of-week="2" lang="es"></date-picker>
                                </b-form-group>
                            </div>
                            <div class="col-sm-12 col-md-6 mb-3">
                                <b-button size="sm" variant="outline-primary" class="mr-2" @click="obtenerRangoPagoActual">Periodo de pago actual</b-button>
                                <b-button size="sm" variant="outline-secondary" @click="limpiarRangoFechas">Ver todo</b-button>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col-md-2 col-sm-6 mb-2">
                                <div class="border rounded p-2 h-100">
                                    <div class="text-muted small">Recibos</div>
                                    <strong>{{ resumenFiltrado.recibos }}</strong>
                                </div>
                            </div>
                            <div class="col-md-2 col-sm-6 mb-2">
                                <div class="border rounded p-2 h-100">
                                    <div class="text-muted small">Laborantes</div>
                                    <strong>{{ resumenFiltrado.laborantes }}</strong>
                                </div>
                            </div>
                            <div class="col-md-2 col-sm-6 mb-2">
                                <div class="border rounded p-2 h-100">
                                    <div class="text-muted small">Horas</div>
                                    <strong>{{ formatHoras(resumenFiltrado.totalHoras) }}</strong>
                                </div>
                            </div>
                            <div class="col-md-3 col-sm-6 mb-2">
                                <div class="border rounded p-2 h-100">
                                    <div class="text-muted small">Total bruto</div>
                                    <strong>{{ format_Valor_variable(resumenFiltrado.totalBruto) }}</strong>
                                </div>
                            </div>
                            <div class="col-md-3 col-sm-6 mb-2">
                                <div class="border rounded p-2 h-100">
                                    <div class="text-muted small">Total líquido</div>
                                    <strong>{{ format_Valor_variable(resumenFiltrado.totalLiquido) }}</strong>
                                </div>
                            </div>
                            <div class="col-md-3 col-sm-6 mb-2">
                                <div class="border rounded p-2 h-100">
                                    <div class="text-muted small">Más recibos</div>
                                    <strong>{{ resumenFiltrado.mayorRecibos ? resumenFiltrado.mayorRecibos.nombre : '-' }}</strong>
                                    <div class="small text-muted">{{ resumenFiltrado.mayorRecibos ? resumenFiltrado.mayorRecibos.recibos + ' recibos' : '' }}</div>
                                </div>
                            </div>
                            <div class="col-md-3 col-sm-6 mb-2">
                                <div class="border rounded p-2 h-100">
                                    <div class="text-muted small">Más horas</div>
                                    <strong>{{ resumenFiltrado.mayorHoras ? resumenFiltrado.mayorHoras.nombre : '-' }}</strong>
                                    <div class="small text-muted">{{ resumenFiltrado.mayorHoras ? formatHoras(resumenFiltrado.mayorHoras.horas) + ' horas' : '' }}</div>
                                </div>
                            </div>
                            <div class="col-md-3 col-sm-6 mb-2">
                                <div class="border rounded p-2 h-100">
                                    <div class="text-muted small">Mayor bruto</div>
                                    <strong>{{ resumenFiltrado.mayorBruto ? resumenFiltrado.mayorBruto.nombre : '-' }}</strong>
                                    <div class="small text-muted">{{ resumenFiltrado.mayorBruto ? format_Valor_variable(resumenFiltrado.mayorBruto.bruto) : '' }}</div>
                                </div>
                            </div>
                            <div class="col-md-3 col-sm-6 mb-2">
                                <div class="border rounded p-2 h-100">
                                    <div class="text-muted small">Mayor líquido</div>
                                    <strong>{{ resumenFiltrado.mayorLiquido ? resumenFiltrado.mayorLiquido.nombre : '-' }}</strong>
                                    <div class="small text-muted">{{ resumenFiltrado.mayorLiquido ? format_Valor_variable(resumenFiltrado.mayorLiquido.liquido) : '' }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 text-muted small">
                                {{ rangoVisible }}
                            </div>
                        </div>
                        <div class="table-responsive mb-0 mt-3">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th >Seleccionar</th>
                                        <th >Nombre</th>
                                        <th >Sede</th>
                                        <th >Fecha</th>
                                        <th >Hora inicio</th>
                                        <th >Hora fin</th>
                                        <th >Código evento</th>
                                        <th >Coordinador</th>
                                        <th >Valor Bruto</th>
                                        <th >Valor Líquido</th>
                                        <!-- <th >Acción</th> -->
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in paginatedData" :key="item.id || index">
                                        <td>
                                            <b-form-checkbox
                                                :id="'checkbox-'+index"
                                                v-model="item.status"
                                                name="checkbox-1"
                                                value="1"
                                                unchecked-value="0"
                                                >
                                                </b-form-checkbox>
                                        </td>
                                        <td>{{ obtenerLabotante(item.laborante_id) }}</td>
                                        <td>{{ obtenerSede(item.laborante_id) }}</td>
                                        <td>{{ formatFecha(item.fecha) }}</td>
                                        <td>{{ item.hora_inicio }}</td>
                                        <td>{{ item.hora_fin }}</td>
                                        <td>{{ obtenerEvento(item.evento_id).codigo }}</td>
                                        <td>{{ obtenerEvento(item.evento_id).coordinador_evento }}</td>
                                        <td>{{ format_Valor_variable(item.valor_bruto) }} </td>
                                        <td>{{ format_Valor_variable(item.valor_liquido) }}</td>
                                        <!-- <td> </td> -->
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-right">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <!-- pagination -->
                                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body text-center" v-else>
                        <h4 class="text-primary">No hay laborantes seleccionados para pagar</h4>
                        <b-button variant="primary" href="/web/laborantes/pagos">Revisar listado</b-button>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>
